import React from 'react';
import { Chip } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

/** Wohin eine Kennung führt — und wie der Datensatz heißt, für den Hinweis beim Verweilen. */
export interface VerweisZiel {
  pfad: string | null;
  titel: string;
}

const VERWEIS = /(\[[A-Z]{1,2}\d+\])/g;

/**
 * Ein Text, in dem jede Kennung — [F1], [T3] — eine Marke ist, die zum
 * Datensatz führt. Eine Kennung, die es nicht gibt, bleibt sichtbar und wird
 * als solche gezeigt: Der Text behauptet dann etwas, das keinen Datensatz
 * hat, und das soll man sehen. Mit `onWahl` übernimmt der Aufrufer den
 * Sprung (etwa, um vorher einen Dialog zu schließen); sonst ist die Marke
 * ein gewöhnlicher Verweis.
 */
export const Satzverweise: React.FC<{
  text: string;
  verweise: Map<string, VerweisZiel>;
  onWahl?: (pfad: string) => void;
}> = ({ text, verweise, onWahl }) => (
  <>
    {text.split(VERWEIS).map((teil, i) => {
      const m = /^\[([A-Z]{1,2}\d+)\]$/.exec(teil);
      if (!m) return <React.Fragment key={i}>{teil}</React.Fragment>;
      const ziel = verweise.get(m[1]);
      const sx = { mx: 0.25, height: 20 };
      if (!ziel) return <Chip key={i} size="small" color="warning" label={`${m[1]} ?`} title="Kein Datensatz mit dieser Kennung" sx={sx} />;
      if (!ziel.pfad) return <Chip key={i} size="small" label={m[1]} title={ziel.titel} sx={sx} />;
      if (onWahl) {
        const pfad = ziel.pfad;
        return <Chip key={i} size="small" label={m[1]} clickable onClick={() => onWahl(pfad)} title={ziel.titel} sx={sx} />;
      }
      return <Chip key={i} size="small" label={m[1]} component={RouterLink} to={ziel.pfad} clickable title={ziel.titel} sx={sx} />;
    })}
  </>
);

export default Satzverweise;
